import SdkTrack from "../Fwk/Kit/SdkTrack";

export enum PrivacyLinkScene {
    Service = 0,  //服务协议
    Privacy = 1,  //隐私协议
}
export default class GameTrack {
    static tag = `[GameTrack]`;
    /**欢迎页相关start */
    //欢迎页面展示时
    static showWelcome() {
        SdkTrack.track513Commit('show_welcome');
    }
    //欢迎页面点击start按钮时
    static clickStart() {
        SdkTrack.track513Commit('click_start_button');
    }
    //欢迎页面点击有账户按钮时
    static clickHaveAccount() {
        SdkTrack.track513Commit('click_acc_button');
    }
    //欢迎页面关闭时
    static closeWelcome() {
        SdkTrack.track513Commit('close_welcome');
    }
    /**欢迎页相关end */

    /**隐私协议相关start */
    //隐私协议页面展示时
    static showPrivacy() {
        SdkTrack.track513Commit('show_policy_page');
    }
    //隐私协议页面点击同意按钮时
    static clickAgreePrivacy() {
        SdkTrack.track513Commit('click_accept');
    }
    //隐私协议点击右上角关闭按钮时
    static clickClosePrivacy() {
        SdkTrack.track513Commit('close_policy_page');
    }
    //点击隐私协议链接，跳出页面时
    static clickPrivacyLink(scene: PrivacyLinkScene) {
        SdkTrack.track513Commit('click_policy_link', ''+scene);
    }
    /**隐私协议相关end */

    /**新手引导相关start */
    static showGuidePage() {
        SdkTrack.track513Commit('show_guide_page');
    }

    static click_guide_gc() {
        SdkTrack.track513Commit('click_guide_gc');
    }
    static click_guide_sc() {
        SdkTrack.track513Commit('click_guide_sc');
    }
    static click_guide_redeem() {
        SdkTrack.track513Commit('click_guide_redeem');
    }
    static click_guide_reward() {
        SdkTrack.track513Commit('click_guide_reward');
    }
    static click_guide_account() {
        SdkTrack.track513Commit('click_guide_account');
    }

    // click_guide_gc
    // click_guide_sc
    // click_guide_redeem
    // click_guide_reward
    // click_guide_account


    //GC玩法引导内容展示时
    // static showGuideGC() {
    //     SdkTrack.track513Commit('show_lead_gc');
    // }
    // //GC玩法引导内容关闭时
    // static closeGuideGC() {
    //     SdkTrack.track513Commit('close_lead_gc');
    // }
    // //SC玩法引导内容展示时
    // static showGuideSC() {
    //     SdkTrack.track513Commit('show_lead_sc');
    // }
    // //SC玩法引导内容关闭时
    // static closeGuideSC() {
    //     SdkTrack.track513Commit('close_lead_sc');
    // }
    // //兑换业引导内容展示时
    // static showGuideRedeem() {
    //     SdkTrack.track513Commit('show_lead_redeem');
    // }
    // //兑换业引导内容关闭时
    // static closeGuideRedeem() {
    //     SdkTrack.track513Commit('close_lead_redeem');
    // }
    // //奖励区域引导内容展示时
    // static showGuideReward() {
    //     SdkTrack.track513Commit('show_lead_reward');
    // }
    // //奖励区域引导内容关闭时
    // static closeGuideReward() {
    //     SdkTrack.track513Commit('close_lead_reward');
    // }
    // //个人中心引导内容展示时
    // static showGuideProfile() {
    //     SdkTrack.track513Commit('show_lead_account');
    // }
    // //个人中心引导内容关闭时
    // static closeGuideProfile() {
    //     SdkTrack.track513Commit('close_lead_account');
    // }
    /**新手引导相关end */

    /**新手福利相关start */
    //新手福利弹窗展示时
    static showNewbieReward() {
        SdkTrack.track513Commit('show_newbie_bonus');
    }
    //新手福利弹窗点击领取按钮时
    static clickNewbieReward() {
        SdkTrack.track513Commit('click_newbie_bonus');
    }
    //新手福利弹窗关闭时
    static closeNewbieReward(value: number) {
        SdkTrack.track513Commit('close_newbie_bonus', value+'');
    }
    /**新手福利相关end */
}

